// removed by extract-text-webpack-plugin
module.exports = {"input":"FormInput__input___yeFWR","input--large":"FormInput__input--large___1WWbd","icon":"FormInput__icon___1hJJ0","icon--unimportant":"FormInput__icon--unimportant___puB2R"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/Input/FormInput.scss
// module id = 1225
// module chunks = 1